import RmnCarouselContent from 'components/Content/RmnCarouselContent/RmnCarouselContent';

export default RmnCarouselContent;
